export default __webpack_public_path__ + "static/SuisseIntl-Regular-WebS-47902d17f845ecb8ae1829ea0a4b0f39.ttf";